module.exports = __webpack_public_path__ + "static/media/icn_service_ratings.358d5e7f.svg";